import type { InteractionMap } from '@analytics/models';
import { Component, inject, input, output } from '@angular/core';
import { TextInterpolationService } from '@core/jss-utils';
import { ProductDuration } from '@essent/common';
import type { CurrentContract } from '@innogy/retention/store';
import { format } from 'date-fns';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackInteractionDirective } from '@analytics/events';
import { CommonModule } from '@angular/common';

import { CommodityOfferLabels } from '../../commodity-offers.model';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';

@Component({
  selector: 'wl-essent-current-contract-card',
  styleUrls: ['./essent-current-contract-card.component.scss'],
  templateUrl: './essent-current-contract-card.component.html',
  providers: [TextInterpolationService],
  standalone: true,
  imports: [
    CommonModule,
    CommodityOfferAccordionComponent,
    CSCaptureDirective,
    AutomationIdDirective,
    TrackInteractionDirective,
  ],
})
export class EssentCurrentContractCardComponent {
  readonly interpolateService = inject(TextInterpolationService);

  readonly currentContract = input<CurrentContract>();
  readonly content = input<CommodityOfferLabels>();
  readonly showLoadingState = input(false);

  readonly openCard = input(true);

  readonly viewTariffs = output<CurrentContract>();

  contractBody(contract: CurrentContract) {
    if (contract.duration === ProductDuration.FLEX) {
      return this.content()?.currentContractBodyVariable;
    } else {
      const endDate = this.mapDate(contract.endDate) ?? null;

      return this.interpolateService.interpolate(
        this.content()?.currentContractBodyFixed,
        { contract_end_date: endDate },
        'plain_text'
      );
    }
  }

  interactionData(contract: CurrentContract): InteractionMap['link'] {
    return {
      name: `huidig contract|bekijk tarieven|${contract.duration}|${contract.contractType}`,
      type: 'button',
    };
  }

  mapDate(date: string | undefined) {
    if (date && /^\d{4}-\d{2}-\d{2}$/.exec(date)) {
      return format(new Date(date), 'dd-MM-yyyy');
    } else {
      return undefined;
    }
  }
}
